module.exports = __webpack_public_path__ + "assets1662726319812/img/lan2.eddb60b0.png";